var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 91.3,
    cy: 73.3,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,60.6h27c5,0,9-4,9-9c0-2.5-1-4.7-2.6-6.4L64.3,17v25.5l7.8,7.8h-13V15.5c-5.7,0-10.3,4.6-10.3,10.3l0,61.7 c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1C59.2,87.2,59.1,60.6,59.1,60.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144,124.7c-4,0-6.1-1.5-8-2.8c-1.7-1.2-3.2-2.3-6.4-2.3c-3.2,0-4.7,1.1-6.4,2.3c-1.9,1.3-4,2.8-8,2.8c-4,0-6.1-1.5-8-2.8 c-1.7-1.2-3.2-2.3-6.4-2.3s-4.7,1.1-6.4,2.3c-1.9,1.3-4,2.8-8,2.8c-4,0-6.1-1.5-8-2.8c-1.7-1.2-3.2-2.3-6.4-2.3s-4.7,1.1-6.4,2.3 c-1.9,1.3-4,2.8-8,2.8s-6.1-1.5-8-2.8c-1.7-1.2-3.2-2.3-6.4-2.3s-4.7,1.1-6.4,2.3c-1.9,1.3-4,2.8-8,2.8s-6.1-1.5-8-2.8 c-1.7-1.2-3.2-2.3-6.4-2.3s-4.7,1.1-6.4,2.3c-1.9,1.3-4,2.8-8,2.8V122c3.2,0,4.7-1.1,6.4-2.3c1.9-1.3,4-2.8,8-2.8s6.1,1.5,8,2.8 c1.7,1.2,3.2,2.3,6.4,2.3s4.7-1.1,6.4-2.3c1.9-1.3,4-2.8,8-2.8s6.1,1.5,8,2.8c1.7,1.2,3.2,2.3,6.4,2.3c3.2,0,4.7-1.1,6.4-2.3 c1.9-1.3,4-2.8,8-2.8s6.1,1.5,8,2.8c1.7,1.2,3.2,2.3,6.4,2.3s4.7-1.1,6.4-2.3c1.9-1.3,4-2.8,8-2.8c4,0,6.1,1.5,8,2.8 c1.7,1.2,3.2,2.3,6.4,2.3s4.7-1.1,6.4-2.3c1.9-1.3,4-2.8,8-2.8c4,0,6.1,1.5,8,2.8c1.7,1.2,3.2,2.3,6.4,2.3V124.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiving);
export default __webpack_public_path__ + "static/media/diving.a28c398ffff086bcc698b436f2bbc1dc.svg";
export { ForwardRef as ReactComponent };